import { render } from "./BpmnDiagramActionsBottom.vue?vue&type=template&id=55834e00&scoped=true"
import script from "./BpmnDiagramActionsBottom.vue?vue&type=script&lang=js"
export * from "./BpmnDiagramActionsBottom.vue?vue&type=script&lang=js"

import "./BpmnDiagramActionsBottom.vue?vue&type=style&index=0&id=55834e00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55834e00"]])

export default __exports__